import { ViewingOtherResourceBanner } from './ViewingOtherResourceBanner';
import { ReadOnlyLockBanner } from './ReadOnlyLockBanner';

export interface TimesheetStatusBannersProps {
  isViewingOtherResource: boolean;
  viewedResourceName: string | null;
  canEditThisTimesheet: boolean;
}

/** Informational banners shown above the week toolbar. */
export function TimesheetStatusBanners({
  isViewingOtherResource,
  viewedResourceName,
  canEditThisTimesheet,
}: TimesheetStatusBannersProps) {
  return (
    <>
      <ViewingOtherResourceBanner
        isViewingOtherResource={isViewingOtherResource}
        viewedResourceName={viewedResourceName}
      />
      <ReadOnlyLockBanner canEditThisTimesheet={canEditThisTimesheet} />
    </>
  );
}
